import { useMutation } from '@tanstack/react-query';

import { sendChat } from './requests';

export const useSendChat = () => {
  return useMutation({
    mutationKey: ['ai-content-assistant-chat'],
    mutationFn: sendChat,
  });
};
